import api from './api';

export const getWebSearchPricing = async () => {
  const { data } = await api.get('/web-search/pricing');
  return data;
};
